module.exports = __webpack_public_path__ + "img/Grupo 1594@2x.da79b2eb.png";